import { FormGroup, FormControl, Validators } from '@angular/forms';
import { FormulaireCoordonneesMouvementAdresseModel } from './formulaire-coordonnees-mouvement-adresse.model';
import { CustomValidators } from 'src/app/validators/custom-validators.validators';
import { AdresseMouvement } from 'src/app/api/model/adresse-mouvement.model';

export class FormulaireCoordonneesMouvementAdresseBuilder {
  static buildAdresse(
    adresseCourante: AdresseMouvement | undefined,
    estDGAGApparie: boolean,
  ): FormGroup<FormulaireCoordonneesMouvementAdresseModel> {
    const formBase = this.buildBaseFormulaireAdresse(adresseCourante, estDGAGApparie);

    if (estDGAGApparie) {
      return new FormGroup<FormulaireCoordonneesMouvementAdresseModel>({
        ...formBase,
        changementAssurancesFait: new FormControl<string | null>(null, {
          nonNullable: true,
          validators: [Validators.required],
        }),
      });
    } else {
      return new FormGroup<FormulaireCoordonneesMouvementAdresseModel>({
        ...formBase,
        detientAssurances: new FormControl<string | null>(null, {
          nonNullable: true,
          validators: [Validators.required],
        }),
      });
    }
  }

  private static buildBaseFormulaireAdresse(
    adresseCourante: AdresseMouvement | undefined,
    estDGAGApparie: boolean,
  ) {
    const province = adresseCourante?.codeSubdivisionPays
      ? (adresseCourante.codeSubdivisionPays.split('-')[1] ?? '')
      : '';
    const numeroCivique = adresseCourante?.numeroCivique ?? '';
    const nomRue = adresseCourante?.nomRue ?? '';
    const numeroCiviqueNomRue =
      numeroCivique && nomRue ? `${numeroCivique} ${nomRue}` : numeroCivique || nomRue || '';

    return {
      numeroCiviqueNomRue: new FormControl<string>(numeroCiviqueNomRue, {
        nonNullable: true,
        validators: [
          CustomValidators.doitAvoirUneSeparation,
          CustomValidators.caracteresAccesDValide,
          CustomValidators.texteNonBlanc,
        ],
      }),
      appartement: new FormControl<string>(adresseCourante?.numeroUnite ?? '', {
        nonNullable: true,
        validators: [CustomValidators.appartement],
      }),
      ville: new FormControl<string>(adresseCourante?.nomMunicipalite ?? '', {
        nonNullable: true,
        validators: [CustomValidators.caracteresAccesDValide, CustomValidators.texteNonBlanc],
      }),
      province: new FormControl<string>(province, { nonNullable: true }),
      codePostal: new FormControl<string>(adresseCourante?.codePostal ?? '', {
        nonNullable: true,
      }),
      codePays: new FormControl<string>(adresseCourante?.codePays ?? 'CA', {
        nonNullable: true,
        validators: [Validators.required],
      }),
      dateDebutUtilisation: new FormControl<string>('', {
        nonNullable: true,
        validators: [Validators.required],
      }),
      detentionDGAGApparie: new FormControl<boolean>(estDGAGApparie, { nonNullable: true }),
    };
  }
}
